import Vue from 'vue';
import Router from 'vue-router';

import pages from './routers';

Vue.use(Router);

const getRouterInstance = () => {
  const router = new Router({
    mode: 'hash',
    base: (window as any).__POWERED_BY_QIANKUN__ ? '/' : process.env.BASE_URL,
    routes: [
      ...pages,
    ],
  });

  router.beforeEach((to: any, from, next) => {
    const { title = 'fe-opportunity-h5' } = to.meta;
    document.title = title;
    next();
  });

  return router;
};

const getRouterConf = (router: any) => ({
  fullPath: router.fullPath,
  hash: router.hash,
  meta: router.meta,
  name: router.name,
  params: router.params,
  path: router.path,
  query: router.query,
});

export default {
  getRouterInstance,
  getRouterConf,
};
